import { render, staticRenderFns } from "./IconBackward.vue?vue&type=template&id=7decdd12&scoped=true"
import script from "./IconBackward.vue?vue&type=script&lang=js"
export * from "./IconBackward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7decdd12",
  null
  
)

export default component.exports